import { useMemo } from 'react'

import { existsInColorGroups } from '../../../../../lib/utils/colors'
import { ColorGroup } from '../../../../../types/graphql'

export type UseProductPagePortalOpts = {
  /** The available color groups for the product group. Expected to only include the color groups that are applicable for the active portal.*/
  portalColorGroups: ColorGroup[]
  /** The active color key for the featured product. This is used to determine whether or not a portal color is currently selected. */
  selectedColorKey?: string
}

/**
 * @deprecated Just check variantGroup.isPortal color from usePdpServerSideProps
 */
export function useProductPagePortal({
  portalColorGroups,
  selectedColorKey,
}: UseProductPagePortalOpts) {
  // Determine if a color from the portal-specific color group is selected
  const isPortalColorSelected = useMemo(
    () => Boolean(selectedColorKey && existsInColorGroups(selectedColorKey, ...portalColorGroups)),
    [portalColorGroups, selectedColorKey]
  )

  return {
    isPortalColorSelected,
  }
}
